// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3GV9w","resendInfoText":"OnGoingPaymentBox_resendInfoText__1pscc"};